export const selectAllQuestions = (state) => state.questions.allQuestions;
